// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/merchandising/shop_display/v1/shop_display.proto (package stailer_service_specification.merchandising.shop_display.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/merchandising/shop_display/v1/shop_display.proto.
 */
const file_stailer_service_specification_merchandising_shop_display_v1_shop_display = /*@__PURE__*/
  fileDesc("Ck5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tZXJjaGFuZGlzaW5nL3Nob3BfZGlzcGxheS92MS9zaG9wX2Rpc3BsYXkucHJvdG8SO3N0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLm1lcmNoYW5kaXNpbmcuc2hvcF9kaXNwbGF5LnYxIsECCgtTaG9wRGlzcGxheRKTAQoQc2hvcF9uYW1lX3ByZWZpeBgBIAEoCUJ5koIZS+OBneOBruS7luOCv+ODluOBp+ihqOekuuOBmeOCi+W6l+iIl+WQjeOBruWJjeOBq+i/veWKoOOBmeOCi+aWh+iogOOBp+OBmeOAgqqCGR7lupfoiJflkI3jg5fjg6zjg5XjgqPjg4Pjgq/jgrm4ghkDwIIZARKbAQoec2hvd19zaG9wX25hbWVfaW5fcHJvZHVjdF9ob21lGAIgASgIQnOSghlF5bqX6IiX5ZCN44KS5aOy44KK5aC044Gu5LiK6YOo44Gr6KGo56S644GZ44KL44GL44KS5oyH5a6a44GX44G+44GZ44CCqoIZHuWjsuOCiuWgtOOBp+OBruW6l+iIl+WQjeihqOekuriCGQPAghkBYgZwcm90bzM", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.merchandising.shop_display.v1.ShopDisplay.
 * Use `create(ShopDisplaySchema)` to create a new message.
 */
const ShopDisplaySchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_merchandising_shop_display_v1_shop_display, 0);


exports.file_stailer_service_specification_merchandising_shop_display_v1_shop_display = file_stailer_service_specification_merchandising_shop_display_v1_shop_display;
exports.ShopDisplaySchema = ShopDisplaySchema;
